export const PROMO_CODES = "PROMO_CODES"

export const PROMO_CODES_UPDATE_ITEM = "PROMO_CODES_UPDATE_ITEM"
export const PROMO_CODES_CREATE_ITEM = "PROMO_CODES_CREATE_ITEM"

export const PROMO_CODES_FETCH_LIST = "PROMO_CODES_FETCH_LIST"
export const PROMO_CODES_UPDATE_LIST = "PROMO_CODES_UPDATE_LIST"
